import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AdminComponent} from './admin.component';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatCardModule} from "@angular/material/card";
import {FilterPipeModule} from "@app/pipes/filter/filter-pipe.module";
import {MatListModule} from "@angular/material/list";
import {MatRadioModule} from "@angular/material/radio";
import {MatTableModule} from "@angular/material/table";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatSortModule} from "@angular/material/sort";
import {LogPipeModule} from "@app/pipes/log/log-pipe.module";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {MatDialogModule} from "@angular/material/dialog";
import {AddUserModule} from "@app/pages/admin/add-user/add-user.module";
import {ExportTableModule} from "@app/commons/export-table/export-table.module";
import {OrderByModule} from "@app/pipes/order-by/order-by.module";


@NgModule({
    declarations: [AdminComponent],
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        MatCardModule,
        FilterPipeModule,
        MatListModule,
        MatRadioModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        LogPipeModule,
        MatIconModule,
        MatButtonModule,
        MatDialogModule,
        AddUserModule,
        ExportTableModule,
        ReactiveFormsModule,
        OrderByModule
    ]
})
export class AdminModule {
}
